export default __webpack_public_path__ + "static/media/speaking.fbcf7d4d.svg";